import { type ConfigEnvironment, type SidebarEntry } from "@package/ui-config";
import {
  type AnimationOption,
  type OrientationType,
  type Resolution,
  type ServiceTypes,
  type Templates,
  type TileRotatePattern,
} from "@package/ui-gql/index-data-access";

export const { ENV_VAR_API_URI_BASE } = import.meta.env;

export const ITEM_GRID_PER_PAGE_DEFAULT = 10;
export const ITEM_GRID_PER_PAGE_OPTIONS = [5, 10, 25, 50, 100];

export const ITEM_GRID_PATH_NEW = "create";
export const ITEM_GRID_PATH_EDIT = "edit";
export const ITEM_GRID_PATH_EDIT_SCHEDULER_GROUP = "edit-group";

export const ITEM_GRID_QUERY_SEARCH_DEBOUNCE_MS = 250;

export const REDUX_SAVE_DEBCOUNCE_MS = 5000;
export const LOCATION_STATUS_POLL_INTERVAL_MS = 60000;

export const WALL_HEIGHT_PREVIEW_AVAILABLE = 384;

const { ENV_VAR_ENVIRONMENT } = import.meta.env;

export const CMS_APP_ENVIRONMENT = ENV_VAR_ENVIRONMENT as ConfigEnvironment;

export enum URL_SEARCH_PARAM_KEY {
  orgId = "orgId",
}

export const EDIT_CARD_WIDTH_CLASS = "max-w-2xl";

export enum SupportedFonts {
  Roboto = "Roboto",
  Arial = "Arial",
  Merriweather = "Merriweather",
  MerriweatherSans = "Merriweather Sans",
  Nunito = "Nunito",
  NunitoSans = "Nunito sans",
  LibreCaslonDisplay = "Libre Caslon Display",
  LibreCaslonText = "Libre Caslon Text",
  ArchivoBlack = "Archivo Black",
}

export enum WeekdayEnum {
  Monday = 0,
  Tuesday = 1,
  Wednesday = 2,
  Thursday = 3,
  Friday = 4,
  Saturday = 5,
  Sunday = 6,
}
export const WeekdayEnumNames: { [key in WeekdayEnum]: string } = {
  [WeekdayEnum.Monday]: "Monday",
  [WeekdayEnum.Tuesday]: "Tuesday",
  [WeekdayEnum.Wednesday]: "Wednesday",
  [WeekdayEnum.Thursday]: "Thursday",
  [WeekdayEnum.Friday]: "Friday",
  [WeekdayEnum.Saturday]: "Saturday",
  [WeekdayEnum.Sunday]: "Sunday",
};

export enum MonthEnum {
  Janurary = 1,
  February = 2,
  March = 3,
  April = 4,
  May = 5,
  June = 6,
  July = 7,
  August = 8,
  September = 9,
  October = 10,
  November = 11,
  December = 12,
}
export const MonthEnumNames: { [key in MonthEnum]: string } = {
  [MonthEnum.Janurary]: "Janurary",
  [MonthEnum.February]: "February",
  [MonthEnum.March]: "March",
  [MonthEnum.April]: "April",
  [MonthEnum.May]: "May",
  [MonthEnum.June]: "June",
  [MonthEnum.July]: "July",
  [MonthEnum.August]: "August",
  [MonthEnum.September]: "September",
  [MonthEnum.October]: "October",
  [MonthEnum.November]: "November",
  [MonthEnum.December]: "December",
};

export const ANIMATION_TYPE_TO_DISPLAY: {
  [key in NonNullable<AnimationOption["__typename"]>]: string;
} = {
  AnimationOptionFlip: "Flip",
  AnimationOptionFade: "Fade",
  AnimationOptionWipe: "Wipe",
};

export const LEGACY_TIMEZONE_MAP: { [key in number]: string } = {
  [-5]: "America/New_York",
  [-6]: "America/Chicago",
  [-7]: "America/Denver",
  [-8]: "America/Los_Angeles",
};

export const ORIENTATION_TYPE_TO_DISPLAY: { [key in OrientationType]: string } =
  {
    landscape: "Landscape",
    portrait: "Portrait",
  };

export const RESOLUTION_TO_DISPLAY: { [key in Resolution]: string } = {
  FHD: "FHD 2K",
  UHD: "UHD 4K",
};

export const SERVICE_TYPE_TO_DISPLAY: { [key in ServiceTypes]: string } = {
  feature: "Feature",
  flyout: "Flyout",
  tile: "Tile",
};

export const TEMPLATE_TO_TILE_COUNT: {
  [key in Templates]: number;
} = {
  Custom: 0,
  FiveByOne: 5,
  FiveByThree: 15,
  OneByFive: 5,
  OneByOne: 1,
  OneByThree: 3,
  ThreeByFive: 15,
  ThreeByOne: 3,
  TwoByTwo: 4,
  ZeroByZero: 0,
};

export const TILE_ROTATE_PATTERN_TO_DISPLAY: {
  [key in TileRotatePattern]: string;
} = {
  horizontal: "Horizontal",
  vertical: "Vertical",
};

export enum SidebarEntryPath {
  locations = "locations",
  tags = "tags",
  media = "media",
  posts = "posts",
  profiles = "profiles",
  scheduler = "scheduler",
  layout = "layout",
  events = "events",
}

export const sidebarEntries: {
  [key in SidebarEntryPath]: SidebarEntry;
} = {
  layout: {
    icon: "layout-left-column-three-tiles",
    text: "Layout",
    path: SidebarEntryPath.layout,
  },
  locations: {
    icon: "desktop",
    text: "Location",
    path: SidebarEntryPath.locations,
  },
  media: {
    icon: "media",
    text: "Media Library",
    path: SidebarEntryPath.media,
  },
  posts: {
    icon: "widget",
    text: "Content",
    path: SidebarEntryPath.posts,
  },
  profiles: {
    icon: "document",
    text: "Canvas",
    path: SidebarEntryPath.profiles,
  },
  scheduler: {
    icon: "timeline-events",
    text: "Schedule",
    path: SidebarEntryPath.scheduler,
  },
  tags: {
    icon: "tags",
    text: "Tag",
    path: SidebarEntryPath.tags,
  },
  events: {
    icon: "timeline-bar-chart",
    text: "Events",
    path: SidebarEntryPath.events,
  },
};
